import yup from '../../../validator';
const MAX_DISCORD_ID_LENGTH = 19;
export const getDiscordIdSchema = () => yup.object({
    discordIdentifier: yup.string().label('Discord ID').max(MAX_DISCORD_ID_LENGTH).matches(/^\d*$/, { excludeEmptyString: true }),
});
